import type { AuthSession, AuthUser } from "@/modules/auth/session-schema";

export interface SignInPayload {
  email: string;
  password: string;
}

export interface AuthBackend {
  signIn: (payload: SignInPayload) => Promise<AuthSession>;
}

const SESSION_TTL_MS = 1000 * 60 * 60 * 8;

const MOCK_USERS: Record<string, AuthUser & { password: string }> = {
  "admin@apoloinventions.com": {
    email: "admin@apoloinventions.com",
    id: "user_admin",
    name: "Seed Admin",
    password: "apolo-seed",
    role: "admin",
  },
  "member@apoloinventions.com": {
    email: "member@apoloinventions.com",
    id: "user_member",
    name: "Seed Member",
    password: "apolo-seed",
    role: "member",
  },
};

function createSessionFor(user: AuthUser): AuthSession {
  const now = Date.now();

  return {
    expiresAt: now + SESSION_TTL_MS,
    issuedAt: now,
    token: `mock-${user.id}-${now.toString(36)}`,
    user,
  };
}

export function createMockAuthBackend(): AuthBackend {
  return {
    async signIn({ email, password }) {
      await new Promise((resolve) => setTimeout(resolve, 120));

      const normalizedEmail = email.trim().toLowerCase();
      const candidate = MOCK_USERS[normalizedEmail];

      if (!candidate || candidate.password !== password) {
        throw new Error("Email and password do not match a seeded account.");
      }

      const { password: _password, ...user } = candidate;
      void _password;
      return createSessionFor(user);
    },
  };
}

export const MOCK_ACCOUNTS = Object.values(MOCK_USERS).map(({ password, ...user }) => ({
  hint: password,
  user,
}));
